import { useState } from "react";

import { DIRECTORY_PAGE_LIMIT_DEFAULT } from "@thalamos/haven-common";

import { apiHooks } from "../../api/index.js";
import { CreateUserDialog } from "../../components/CreateUserDialog/CreateUserDialog.js";
import { createRoute } from "../../routing/createRoute.js";
import { useCreateUser } from "./useCreateUser.js";
import { useDirectoryQuery } from "./useDirectoryQuery.js";
import { UsersListContent } from "./UsersListContent.js";

/** Every account, filtered by name or email address. */
export const AdminUsersPage = () => {
  const { query, input, offset, setQuery, setOffset } = useDirectoryQuery();
  const [creating, setCreating] = useState(false);

  const [{ data, loading, error }] = apiHooks.admin.users({
    query,
    offset,
    limit: DIRECTORY_PAGE_LIMIT_DEFAULT,
  });

  // Asked only while the dialog is open: it is a search across every
  // organisation, and nothing else on the page needs it.
  const organisationQuery = useDirectoryQuery();
  const [{ data: organisations }] = apiHooks.admin.organisations(
    { query: organisationQuery.query, limit: DIRECTORY_PAGE_LIMIT_DEFAULT },
    { manual: !creating },
  );

  const create = useCreateUser(createRoute.adminUser);

  return (
    <>
      <UsersListContent
        page={data}
        loading={loading}
        failed={error !== undefined && error !== null}
        filter={input}
        onFilter={setQuery}
        offset={offset}
        onPageChange={setOffset}
        accountPath={createRoute.adminUser}
        onCreateUser={() => {
          setCreating(true);
        }}
      />
      <CreateUserDialog
        open={creating}
        organisations={organisations?.results ?? []}
        organisationSearch={{
          input: organisationQuery.input,
          onInput: organisationQuery.setQuery,
        }}
        onClose={() => {
          setCreating(false);
        }}
        onCreate={create}
      />
    </>
  );
};
